import React from "react";
import general from "../../../../../../general";
import CustomCardBase from "./CustomCardBase";

// subType=4 社区攻略
export default function CommunityStrategyMessage({ msg }) {
  const { attach } = msg;
  return (
    <CustomCardBase
      tagColor="#EB475F"
      tagText="攻略"
      title={attach?.title}
      gameInfo={attach?.game_info}
      desc={attach?.content}
      descClass="imc-line3"
      onClick={() => {
        general.game = attach?.game_info;
        general.history.push(
          "/communityDetail?id=" + attach?.id +
          "&tagid=" + attach?.tagid +
          "&circles_type=" + attach?.circles_type +
          "&topic_id=" + attach?.topic_id
        );
      }}
    />
  );
}
